<template>
  <div class="sidebar-left" :class="[SIDE_MENU == 1 ? 'opensidebar':'closesidebar' ]">
    <ToolbarIcon/>
    <div class="sidebar-body scroll-pane">
      <div class="side-nav">
        <div
          v-for="(menuItems, index) in menu"
          :key="index"
          class="menu-group"
        >
          <router-link
            v-for="(item, index1) in menuItems"
            :key="index1"
            :to="item.route"
            class="menu-item"
            @click.native="Toggle"
          >
            <font-awesome-icon :icon="item.icon" class="icon menu-icon" /> <span class="ml-3 menu-text">{{ $t(item.title) }}</span>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/babel">
  import {mapActions, mapGetters} from "vuex";
  import ToolbarIcon from "./ToolbarIcon";

export default {
  components: {ToolbarIcon},
  data () {
    return {
      sidebar: 'sidebar',
      menu: [
        [
          {
            title: 'navigation.dashboard',
            icon: 'tachometer-alt',
            route: '/anchor/dashboard'
          },
          // {
          //   title: 'navigation.customers',
          //   icon: 'user',
          //   route: '/anchor/customers'
          // },
          {
            title: 'navigation.suppliers',
            icon: 'user-secret',
            route: '/anchor/suppliers'
          }
        ],
        [
          {
            title: 'navigation.pos',
            icon: 'file',
            route: '/anchor/purchase-orders'
          },
          {
            title: 'navigation.invoices',
            icon: 'file-alt',
            route: '/anchor/invoices'
          },
          {
            title: 'navigation.payments',
            icon: 'credit-card',
            route: '/anchor/payments'
          },
          {
            title: 'navigation.preapproved_invoices',
            icon: 'file-invoice',
            route: '/anchor/preapproved-invoices'
          }
        ],
        [
          {
            title: 'navigation.reports',
            icon: 'signal',
            route: '/anchor/reports'
          },
          {
            title: 'navigation.data_exports',
            icon: 'file-export',
            route: '/anchor/data-exports'
          }
        ],
        [
          {
            title: 'navigation.settings',
            icon: 'cog',
            route: '/anchor/settings'
          },
          {
            title: 'navigation.user_guides',
            icon: 'file-pdf',
            route: '/anchor/user-guides'
          }
        ]
      ]
    }
  },
  created () {
    if (localStorage.getItem('role') === 'admin') {
      this.menu.splice(3, 0, [
        {
          title: 'navigation.user_management',
          icon: 'users-cog',
          route: '/anchor/user-managements'
        }
      ])
    }
  },

  computed: {
    ...mapGetters('general', [
      'SIDE_MENU'
    ]),
  },
  methods: {

    Toggle () {
      this.$utils.toggleSidebar()
    }
  }
}
</script>
